"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUpdateLanguageStartDialogMessage = void 0;
const _1 = require(".");
function isUpdateLanguageStartDialogMessage(message) {
    return message.type === _1.StartDialogMessageType.UpdateLanguage;
}
exports.isUpdateLanguageStartDialogMessage = isUpdateLanguageStartDialogMessage;
